import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
import { omit, pick } from 'lodash-es';
import Message from './index';
function getPosition(messageRect, elementRect, placement) {
  var messageWidth = messageRect.width,
    messageHeight = messageRect.height;
  var left = elementRect.left,
    right = elementRect.right,
    top = elementRect.top,
    width = elementRect.width;
  switch (placement) {
    case 'top':
      // 28: 距离 dom 20px + ant-message top 8px
      return {
        left: `${left + width / 2 - messageWidth / 2}px`,
        top: `${top - messageHeight - 28}px`
      };
    case 'topRight':
      return {
        left: `${right - messageWidth}px`,
        top: `${top - messageHeight - 28}px`
      };
    case 'topLeft':
      return {
        left: `${left}px`,
        top: `${top - messageHeight - 28}px`
      };
    default:
      return {};
  }
}
export function setMessageTip(element, config, info) {
  var _config$style, _config$style2;
  var type = info.type,
    _info$placement = info.placement,
    placement = _info$placement === void 0 ? 'top' : _info$placement;
  if (config !== null && config !== void 0 && (_config$style = config.style) !== null && _config$style !== void 0 && _config$style.left && config !== null && config !== void 0 && (_config$style2 = config.style) !== null && _config$style2 !== void 0 && _config$style2.top) {
    Message[type](config);
  } else {
    var commonStyle = {
      padding: 0,
      position: 'absolute'
    };
    Message[type](_objectSpread(_objectSpread({}, pick(config, ['icon', 'content'])), {}, {
      className: `${config.className} sk-message-dom`,
      style: _objectSpread(_objectSpread(_objectSpread({}, config.style), commonStyle), {}, {
        left: -1000,
        top: -1000
      }),
      duration: 0.01,
      key: 'sk-message-dom'
    })).then(() => {
      var _document$getElements;
      var message = (_document$getElements = document.getElementsByClassName('sk-message-dom')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
      var messageRect = message.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      var outputConfig = _objectSpread(_objectSpread({}, omit(config, ['style', 'className'])), {}, {
        className: `${config.className} sk-message-tip`,
        style: _objectSpread(_objectSpread(_objectSpread({}, config.style), commonStyle), getPosition(messageRect, elementRect, placement))
      });
      setMessageTip(element, outputConfig, info);
    });
  }
}